import React from 'react';
import { Anchor, MapPin, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { boatInfo } from '../data/mock';

export const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_marine-reserve-app/artifacts/jap76znk_IMG_3234.jpeg"
          alt="The Myli Boat - Expérience Sunset"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/60 via-blue-800/50 to-orange-900/60"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
      </div>

      {/* Animated Elements */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-orange-500/20 rounded-full blur-3xl animate-pulse delay-1000"></div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 lg:px-8 py-32 text-center">
        <div className="max-w-4xl mx-auto space-y-8">
          {/* Slogan */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-6 py-3 text-white">
            <Anchor className="w-5 h-5" />
            <span className="text-base font-medium italic">Vous ne louez pas un bateau, vous vivez une expérience</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-tight">
            Vivez l'expérience
            <br />
            <span className="bg-gradient-to-r from-orange-300 via-pink-300 to-orange-400 bg-clip-text text-transparent">
              Méditerranéenne
            </span>
          </h1>

          {/* Description */}
          <p className="text-xl md:text-2xl text-white/90 max-w-2xl mx-auto leading-relaxed">
            Découvrez la beauté de Marseille à bord du <span className="font-semibold">{boatInfo.model}</span>. 
            Couchers de soleil magiques, prestations culinaires et moments inoubliables.
          </p>

          {/* Location Badge */}
          <div className="flex items-center justify-center gap-2 text-white/80">
            <MapPin className="w-5 h-5" />
            <span className="text-lg">{boatInfo.location.name}, Marseille</span>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-6">
            <Button 
              size="lg"
              onClick={scrollToContact}
              className="bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 text-white text-lg px-8 py-6 shadow-2xl hover:shadow-orange-500/50 transition-all hover:scale-105 group"
            >
              Réserver maintenant
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button 
              size="lg"
              variant="outline"
              onClick={() => document.getElementById('time-slots')?.scrollIntoView({ behavior: 'smooth' })}
              className="border-2 border-white text-white hover:bg-white hover:text-blue-900 text-lg px-8 py-6 backdrop-blur-sm bg-white/10 transition-all hover:scale-105"
            >
              Découvrir nos offres
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-8 max-w-3xl mx-auto pt-12">
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">5.5m</div>
              <div className="text-white/70 text-sm">Bateau à moteur</div>
            </div>
            <div className="text-center border-l border-r border-white/20">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">4</div>
              <div className="text-white/70 text-sm">Créneaux horaires</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">★ 5.0</div>
              <div className="text-white/70 text-sm">Avis clients</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-white/70 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};
